import { render, staticRenderFns } from "./[change-id].vue?vue&type=template&id=28207f6f"
import script from "./[change-id].vue?vue&type=script&lang=js"
export * from "./[change-id].vue?vue&type=script&lang=js"
import style0 from "./[change-id].vue?vue&type=style&index=0&id=28207f6f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports